import type { InjectionKey, WritableComputedRef } from "vue";

export const MonitorViewInjectionKey = Symbol("MonitorViewInjectionKey") as InjectionKey<
  WritableComputedRef<boolean>
>;
